export enum ViewPortSizes {
    s = 576,
    m = 768,
    l = 992,
    xl = 1200
}
